import { useTranslation } from "react-i18next";

import { IconInbox01 } from "@pentabd/icons";
import { Button } from "@pentabd/ui";

import { EmployeeHeader } from "@components";

import { useLanguage } from "@hooks/useLanguage";
import { useUser } from "@hooks/useUser";

import { getAccess } from "@helpers/permissionController";

import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";
import { RequisitionDetailsResponseType } from "@type/inventory/requisition-details";

import { ROUTES } from "@constants/routes";
import { REQUSITION_STATUS } from "@constants/status.inventory";

type Props = {
  handleAssignProducts: () => void;
  showAssignButton: boolean;
  data: RequisitionDetailsResponseType | null;
};

export const RequisitionDetailsPageHeader = ({
  handleAssignProducts,
  showAssignButton,
  data,
}: Props) => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  const { status, employee } = data || {};

  const breadcrumbs = [
    {
      icon: <IconInbox01 fill="dark" size="20" />,
    },
    {
      label: t("SIDEBAR.INVENTORY.REQUISITION"),
      link: ROUTES.INVENTORY.REQUISITION,
    },
    {
      label: language === "bn" ? employee?.nameBn : employee?.nameEn,
    },
  ];

  return (
    <EmployeeHeader
      breadcrumbs={breadcrumbs}
      employee={employee as EmployeeCommonInfoType}
      actions={[
        getAccess(roles, "REQUISITION_ASSIGN") &&
        status === REQUSITION_STATUS.APPROVED &&
        showAssignButton ? (
          <Button
            fill="fill"
            type="primary"
            size="xs"
            onClick={(e) => {
              handleAssignProducts();
            }}
          >
            {t("INVENTORY_REQUISITION.REQUISITION_DETAILS.ASSIGN")}
          </Button>
        ) : (
          <></>
        ),
      ]}
    />
  );
};
